var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fretboards),function(fretboard,index){return _c('FretboardComponent',{key:index,attrs:{"instrument":fretboard.instrument,"bubbles":fretboard.bubbles}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }